<template>
  <div class="bootstrap app-container"><slot></slot></div>
</template>

<style lang="scss" scoped>
.app-container {
  height: 100dvh;
  min-height: 0;
  padding: 0;
  overflow-y: auto;
}
</style>
